import { mode } from '@chakra-ui/theme-tools'
// oxlint-disable-next-line typescript/no-explicit-any
type Dict = Record<string, any>

function baseStyleTrack(props: Dict): Dict {
  return {
    bg: mode('greys.100', 'whiteAlpha.300')(props),
  }
}

export default {
  baseStyle: (props: Dict): Dict => ({
    track: baseStyleTrack(props),
  }),
}
